import { render, staticRenderFns } from "./MergePasienDetails.vue?vue&type=template&id=12c2cae3"
import script from "./MergePasienDetails.vue?vue&type=script&lang=js"
export * from "./MergePasienDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c2cae3')) {
      api.createRecord('12c2cae3', component.options)
    } else {
      api.reload('12c2cae3', component.options)
    }
    module.hot.accept("./MergePasienDetails.vue?vue&type=template&id=12c2cae3", function () {
      api.rerender('12c2cae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/MergePasienDetails.vue"
export default component.exports